<template>
  <b-form inline>
    <ChangeStateSelect :ticket="this.ticket"
    @changeState="childVal => {
      transition = childVal.transition
    }" class="mr-2"/>
    <MarkDuplicatedModal v-if="this.ticket.propers_estats.find(estat => estat.trigger == 'markDuplicated')"
    :originTicket="this.ticket.id"
    :showDuplicatedModal="this.transition == 'markDuplicated'"
    @updateNewTicketAssigned="childVal => {
      newTicketAssigned = childVal
    }"/>
  </b-form>
</template>

<script>
import ChangeStateSelect from '@/components/ChangeStateSelect'
import MarkDuplicatedModal from '@/components/MarkDuplicatedModal'

export default {
  components: {
    ChangeStateSelect,
    MarkDuplicatedModal
  },
  props: {
    ticket: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      transition: null,
      newTicketAssigned: null

    }
  },
  watch: {
    transition: function (newVal) {
      this.$emit('updateTransition', newVal)
    },
    newTicketAssigned: function (newVal) {
      this.$emit('updateNewTicketAssigned', newVal)
    }

  }
}
</script>

<style scoped>
</style>
